import React, { useEffect } from "react";
import _ from "lodash";
import { EVENT_PLANNING_RECRUITMENT_PLAN } from "../../../plannerConfig";
import {
  PeakCartonCountContainer,
  RecruitmentViewMainGrid,
  VerticalTableHeaderContainer,
  VerticalTableHeaderItem,
  HorizontallyScrollable,
  HeaderRow,
  HeaderRowItem,
  EntryRowContainer,
  EntryRow,
  EntryItem,
  TableAVerticalHeaders,
  TableAMainFlexContainer,
  ItemsMainContainer,
  ItemRow,
  Item,
  HeaderItem,
} from "./styles";
import { MultiWeekPlannerMainContainer } from "../multiWeekStyles.common";
import LoadSpinnerOverlay from "../../LoadSpinner";

const RecruitmentPlanDateHeader = ({ date }) => (
  <HeaderRowItem>{date}</HeaderRowItem>
);

const RecruitmentRow = ({ data, dataKey, dates }) => {
  const dataHunk = data[dataKey];

  return (
    <EntryRow>
      {dates.map((date) => (
        <EntryItem>{dataHunk[date]}</EntryItem>
      ))}
    </EntryRow>
  );
};

const PeakDayView = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_RECRUITMENT_PLAN];

  const getRecruitmentPlanDat = () => {
    const { get } = api;
    const buildSelectedScenariosString = selectedScenarios
      .map((scenario) => `scenario_id=${scenario.id}`)
      .join("&");
    if (fromDate && toDate) {
      get([EVENT_PLANNING_RECRUITMENT_PLAN], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: `${buildSelectedScenariosString}&`,
        },
      });
    }
  };

  useEffect(() => {
    getRecruitmentPlanDat();
  }, [
    fromDate,
    toDate,
    fromDateFilter,
    toDateFilter,
    durationAggregator,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay text="Inbound Volume Loading..." spinning={true} />
      </div>
    );
  }

  const { CallOut, TableA, TableB } = data;

  const mutateCallOut = CallOut.data;

  const {
    name: centerCalloutName,
    value: centerCalloutValue,
    bold: centerCalloutBold,
  } = mutateCallOut.slice(0, 1)[0];

  const splitCallouts = mutateCallOut.slice(1, 5);

  const { data: tableAData, title, labels } = TableA;

  const tableASpacedKey = ["", ...Object.keys(tableAData)];
  const tableAKeys = Object.keys(tableAData);

  const { dates, data: tableBData } = TableB;
  const tableBKeys = Object.keys(tableBData);

  return (
    <MultiWeekPlannerMainContainer>
      <RecruitmentViewMainGrid>
        <div
          className="callout"
          style={{
            gridArea: "callout",
            flexDirection: "column",
            display: "flex",
            flex: 1,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <div
              style={{
                margin: "1em",
                width: "60%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PeakCartonCountContainer bold={centerCalloutBold}>
                {`${centerCalloutName} -  ${centerCalloutValue}`}
              </PeakCartonCountContainer>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {splitCallouts.map(({ name, value, bold }) => {
              return (
                <div style={{ width: "100%", flex: "40%", margin: "0.5em" }}>
                  <PeakCartonCountContainer bold={bold}>
                    {`${name} - ${value}`}
                  </PeakCartonCountContainer>
                </div>
              );
            })}
          </div>
        </div>
        <div
          className="tableA"
          style={{ gridArea: "tableA", display: "flex", margin: "1em" }}
        >
          <TableAMainFlexContainer>
            <TableAVerticalHeaders>
              {tableASpacedKey.map((key) => (
                <Item>{key}</Item>
              ))}
            </TableAVerticalHeaders>
            <ItemsMainContainer>
              <ItemRow>
                {labels.map((label) => (
                  <HeaderItem>{label}</HeaderItem>
                ))}
              </ItemRow>
              {tableAKeys.map((key) => (
                <ItemRow>
                  {labels.map((label) => {
                    return <Item>{tableAData[key][label]}</Item>;
                  })}
                </ItemRow>
              ))}
            </ItemsMainContainer>
          </TableAMainFlexContainer>
        </div>
        <div
          className="tableB"
          style={{
            gridArea: "tableB",
            display: "flex",
            flexDirection: "row",
            margin: 1,
          }}
        >
          <VerticalTableHeaderContainer>
            <VerticalTableHeaderItem>Date</VerticalTableHeaderItem>
            {tableBKeys.map((key) => (
              <VerticalTableHeaderItem key={key}>{key}</VerticalTableHeaderItem>
            ))}
          </VerticalTableHeaderContainer>
          <HorizontallyScrollable>
            <HeaderRow>
              {dates.map((date) => (
                <RecruitmentPlanDateHeader key={date} date={date} />
              ))}
            </HeaderRow>
            <EntryRowContainer>
              {tableBKeys.map((key, index) => (
                <RecruitmentRow
                  key={`${key}+${index}`}
                  data={tableBData}
                  dates={dates}
                  dataKey={key}
                />
              ))}
            </EntryRowContainer>
          </HorizontallyScrollable>
        </div>
      </RecruitmentViewMainGrid>
    </MultiWeekPlannerMainContainer>
  );
};

export default PeakDayView;
